import Switch from 'react-switch'
import { useTheme } from '@nfinite/react-hubstairs/styled'
import useTranslate from 'hooks/useTranslate'

import Template, { LabelCappedCenter } from 'components/Commons/Inputs/Template'

import { Container, Label, SwitchWrapper, NullStateSwitch, RightLabel } from './styled'

const INPUT_SIZE = {
  sm: {
    height: 20,
    width: 35,
    handleDiameter: 16,
  },
  default: {
    height: 30,
    width: 50,
    handleDiameter: 18,
  },
}

function SwitchComponent({ name, checked, onChange, disabled, dataTestId, isNullState, ...toggleProps }) {
  const {
    colors: {
      primary: { main: primaryMain, contrast: primaryContrast },
      secondary: { main: secondaryMain, contrast: secondaryContrast },
    },
  } = useTheme()

  const inputSize = INPUT_SIZE[toggleProps.inputSize ?? 'default']

  return (
    <SwitchWrapper onClick={event => event.stopPropagation()}>
      {isNullState ? (
        <NullStateSwitch onClick={onChange} />
      ) : (
        <Switch
          id={name}
          onColor={primaryMain}
          onHandleColor={primaryContrast}
          offColor={secondaryMain}
          offHandleColor={secondaryContrast}
          handleDiameter={toggleProps.handleDiameter ?? inputSize.handleDiameter}
          width={inputSize.width}
          height={inputSize.height}
          onChange={onChange}
          checked={!!checked}
          uncheckedIcon={false}
          checkedIcon={false}
          disabled={disabled}
          {...toggleProps}
          data-testid={dataTestId}
        />
      )}
    </SwitchWrapper>
  )
}

export function ToggleStandalone({
  name,
  checked,
  onChange,
  label: labelIntl,
  rightLabel: rightLabelIntl,
  disabled,
  canClickContainer = false,
  dataTestId,
  className,
  ...toggleProps
}) {
  const translate = useTranslate()
  const label = translate(labelIntl)
  const rightLabel = rightLabelIntl ? translate(rightLabelIntl) : undefined
  const isClickable = !disabled && canClickContainer

  function handleContainerClick(e) {
    e.preventDefault()
    e.stopPropagation()
    onChange(!checked)
  }

  return (
    <Container className={className} isClickable={isClickable} onClick={isClickable ? handleContainerClick : undefined}>
      {label && (
        <Label htmlFor={!disabled ? name : undefined} isClickable={isClickable}>
          {label}
        </Label>
      )}
      <SwitchComponent
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        dataTestId={dataTestId}
        {...toggleProps}
      />
      {rightLabel && <RightLabel htmlFor={!disabled ? name : undefined}>{rightLabel}</RightLabel>}
    </Container>
  )
}

function Toggle({
  name,
  className,
  onChange,
  checked,
  label,
  error,
  isRequired,
  disabled,
  dataTestId,
  layoutConfiguration,
  ...toggleProps
}) {
  return (
    <Template
      label={label}
      name={name}
      error={error}
      Wrapper={LabelCappedCenter}
      layoutConfiguration={layoutConfiguration}
      isRequired={isRequired}
      disabled={disabled}
      className={className}
    >
      <SwitchComponent
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        dataTestId={dataTestId}
        {...toggleProps}
      />
    </Template>
  )
}

export default Toggle
